import { render } from "./AddCustomerForVoucher.vue?vue&type=template&id=47f5691c&scoped=true"
import script from "./AddCustomerForVoucher.vue?vue&type=script&lang=js"
export * from "./AddCustomerForVoucher.vue?vue&type=script&lang=js"

import "./AddCustomerForVoucher.vue?vue&type=style&index=0&id=47f5691c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f5691c"]])

export default __exports__